// Static catalog of installable modules used by the Plans CRUD UI (the
// "included modules" picker in PlanModal / plan cards). This isn't a DB
// table — plan rows just store the selected module keys in
// platform.subscription_plans.features.modules (jsonb) — so this catalog
// stays a plain constant, ported verbatim from CliqSuite_Admin.dc.html
// (plus mcp/guest_portal/counter, added after that mockup for modules that
// didn't exist yet). Most of these are purely informational here — Owner
// Portal's own Modules page lets a business toggle them freely regardless
// of plan — except the keys in services/sync-api's PLAN_GATED_MODULES /
// guestPortalGate, which are also enforced server-side.
export const MODULE_CATALOG: Array<{ key: string; name: string; icon: string }> = [
  { key: "pos", name: "POS", icon: "point_of_sale" },
  { key: "payments", name: "Payments", icon: "qr_code_2" },
  { key: "reports", name: "Reports", icon: "trending_up" },
  { key: "inventory", name: "Inventory", icon: "inventory_2" },
  { key: "crm", name: "CRM & Loyalty", icon: "groups" },
  { key: "service", name: "Appointments", icon: "event_available" },
  { key: "catalog", name: "Service Catalog", icon: "spa" },
  { key: "restaurant", name: "Restaurant", icon: "restaurant" },
  { key: "retail", name: "Retail", icon: "shopping_bag" },
  { key: "apparel", name: "Apparel", icon: "checkroom" },
  { key: "electronics", name: "Electronics", icon: "devices" },
  { key: "pharmacy", name: "Pharmacy", icon: "medication" },
  { key: "counter", name: "Retail Register", icon: "point_of_sale" },
  { key: "guest_portal", name: "Guest Portal", icon: "phone_iphone" },
  { key: "mcp", name: "AI access (MCP)", icon: "smart_toy" },
];

export const PLAN_CORE_MODS = ["pos", "payments", "reports"];
